import ReCAPTCHA from 'react-google-recaptcha'
import React, { forwardRef, useEffect, useState } from 'react'

export const Captcha = forwardRef(function Captcha(
  { onChange = function () {} },
  ref,
) {
  const [recaptchaValue, setRecaptchaValue] = useState(null)

  useEffect(() => {
    onChange(recaptchaValue)
  }, [recaptchaValue])

  const changeHandler = e => {
    setRecaptchaValue(e)
  }
  return (
    <ReCAPTCHA
      // asyncScriptOnLoad={onLoaded}
      ref={ref}
      sitekey={process.env.GOOGLE_RECAPTCHA_SITE_KEY}
      onChange={changeHandler}
    />
  )
})
